import { useTheme } from '@emotion/react';
import React__default, { forwardRef, cloneElement } from 'react';
import { Label } from '../../../Label/index.js';
import { Message } from '../../../Message/index.js';
import { StyledInput } from '../../styles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { getColor } from '../../../../utils/themeUtils.js';
import { Colors } from '../../../../primitives/color.js';
import { cssShorthandPropsFilter, Spacer } from '../../../../primitives/Spacer/index.js';

const SELECTED = 'selected';
const INDETERMINATE = 'indeterminate';
const UNSELECTED = 'unselected';
const BaseSwitch = forwardRef(function ForwardedCheckbox({
  ['aria-label']: ariaLabel,
  ['data-testid']: dataTestId,
  children,
  description,
  disabled,
  error,
  indeterminate,
  iconSelected,
  iconIndeterminate,
  iconUnselected,
  inputSize = 'md',
  inputType,
  ...props
}, ref) {
  const theme = useTheme();
  const inputProps = {
    disabled,
    ...props
  };
  const svgProps = {
    size: inputSize,
    color: disabled ? getColor(Colors.gray[300], Colors.gray[600])({
      theme
    }) : getColor(Colors.black, Colors.white)({
      theme
    })
  };
  const IconSelected = cloneElement(iconSelected, {
    className: SELECTED,
    ...svgProps
  });
  const IconIndeterminate = iconIndeterminate && cloneElement(iconIndeterminate, {
    className: INDETERMINATE,
    ...svgProps
  });
  const IconUnselected = cloneElement(iconUnselected, {
    className: UNSELECTED,
    ...svgProps
  });
  const hasMessage = Boolean(description) || Boolean(error);
  return jsxs(Label, {
    "aria-label": ariaLabel,
    "data-testid": `${dataTestId}-label`,
    disabled: disabled,
    hasInlineError: Boolean(error),
    hasMessage: hasMessage,
    isInline: true,
    isBold: false,
    size: inputSize,
    ...cssShorthandPropsFilter(props),
    children: [jsxs(Spacer, {
      pr: 1,
      children: [jsx(StyledInput, {
        "data-testid": dataTestId,
        ref: ref,
        ...inputProps,
        type: inputType
      }), indeterminate ? IconIndeterminate : jsxs(React__default.Fragment, {
        children: [IconSelected, IconUnselected]
      })]
    }), children && jsx(Spacer, {
      pr: 2,
      children: children
    }), hasMessage && jsx(Message, {
      disabled: disabled,
      error: error,
      message: description
    })]
  });
});

export { BaseSwitch };
